import { Button } from 'antd';
import { ConfirmDelete } from '@ui/modals';
import { coreActions } from '@sonar-software/sonar-core';
import { getClosestCardHeader } from '@lib/popups';
import { haltClickEventPropagation } from '@lib/events';
import { useNavigate } from 'react-router-dom';
import { COPY_SPECIFIC, FULL_ROUTES, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser } from '@hooks';
export const HideAppButton = ({ applicationId }) => {
    const { isReadOnly } = useCurrentUser();
    const navigate = useNavigate();
    const hideApplication = useAction(coreActions.requestDeleteCoreDataSecurityApplications);
    const handleHide = useCallback(() => {
        hideApplication({ applicationId });
        navigate(FULL_ROUTES.DATA_SECURITY);
    }, [applicationId, hideApplication, navigate]);
    if (isReadOnly) {
        return null;
    }
    return (React.createElement(ConfirmDelete, { className: 'confirm-hide', confirmButtonProps: {
            value: COPY_SPECIFIC.HIDE
        }, getPopupContainer: getClosestCardHeader, onConfirm: handleHide, title: MESSAGES_COPY.ARE_YOU_SURE_INTEGRATION_APP },
        React.createElement(Button, { onClick: haltClickEventPropagation }, COPY_SPECIFIC.HIDE)));
};
